import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WorkspaceContext = createContext(null);

export function WorkspaceProvider({ children }) {
  const { user } = useAuth();
  const [workspaces, setWorkspaces] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem("pp-ws") || null);

  const refresh = useCallback(async () => {
    if (!user) return;
    const { data } = await api.get("/workspaces");
    setWorkspaces(data);
    setActiveId((cur) => {
      if (cur && data.find((w) => w.id === cur)) return cur;
      return data[0]?.id || null;
    });
  }, [user]);

  useEffect(() => { if (user) refresh(); }, [user, refresh]);
  useEffect(() => { if (activeId) localStorage.setItem("pp-ws", activeId); }, [activeId]);

  const active = workspaces.find((w) => w.id === activeId) || null;

  return (
    <WorkspaceContext.Provider value={{ workspaces, active, activeId, setActiveId, refresh }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export const useWorkspace = () => useContext(WorkspaceContext);
